import { Component, OnInit } from '@angular/core';
import { WebParameterContext } from '../../../model/common';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridBaseCase } from '../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
import { MessageclientService } from '../../../service/messageclient.service';
import { HandleServerContextAfterDBRequest, HandleWebParameterContextBeforeDBRequest } from '../../../bizlogic/servicesbll';
declare var app;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent extends GridBaseCase {
  searchVal = '';
  loading: boolean = true;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
     private com: CommonService,
    private router: Router) { super(); }

  ngOnInit() {
    this.gridDataList = null;
  }

  searchChange() {
    this.gridDataList = null;
    if (/^1[0-9]{10}$/.test(this.searchVal)) {
      console.log(this.searchVal);
      localStorage.setItem('searchVal', this.searchVal);
      this.getCustomerInfo(this.searchVal);
    }
  }

  /**
   * 获取消费者信息
   * @param phone 
   */
  getCustomerInfo(phone) {
    let that = this;
    that.loading = false;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.template.content.configName) {
      body.ConfigName = that.template.content.configName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // body.RequestBody = JSON.stringify({ 'a_ShouJiHaoMa': phone });
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }, 100);
      if (data.ResponseMessage.Success) {
        that.gridDataList = [];
        // that.gridDataList = data.Status.Datas;
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          if (that.template.content) {
            that.template.content.element[0].selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = item[element.field];
              }
              if (element.bindingField == 'date' && item[element.field]) {
                objfield[element.bindingField] = item[element.field].replace('00:00:00', '');
              }
            });
            that.gridDataList.push(objfield);
          }
          // console.log(that.element.selectItemList.selectItem);
        });
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

  addCustomer(url) {
    if (url) {
      localStorage.removeItem("form_temp");
      this.com.Go(url+"/add");
      
    }
  }

  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        console.log(evs, parms);
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        this.com.Go(evs + "/edite/" + parms.id);
      }
    }
  }

}
